/* eslint-disable eqeqeq */
import { PureComponent, Fragment } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ShowMoreText from 'react-show-more-text';
import collect from 'collect.js';

import {
  Button,
  Checkbox,
  Divider,
  Grid,
  Icon,
  Modal,
  Segment,
} from 'semantic-ui-react';

import { CustomTooltip } from '../../../components';

import {
  filter,
  find,
  get,
  isEmpty,
  isObject,
  map,
} from '../../../utils/lodash';

import { putActivity, putParentDomain } from '../../../store/actions';
import { getPageDisable } from '../../../utils';
import ProjectText from '../../../components/projectText';
import { isParentProgramActivity } from '../../../utils/activity';

import './activity.scss';

/**
 * RemainderDuplicate
 *
 * This component displays a modal when a newly duplicated
 * activity page is first loaded.
 */
class RemainderDuplicate extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t, modal, toggle } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => toggle()}
        closeIcon={
          <Icon onClick={() => toggle()} name="close" className="closeicon" />
        }
        size="small"
      >
        <Modal.Header>{t('activity.goal.duplicate_modal_title')}</Modal.Header>
        <Modal.Content>
          <div>{t('activity.goal.duplicate_modal_body')}</div>
        </Modal.Content>
        <Modal.Actions>
          <div className="model-buttons">
            <Button
              content={t('actions.got_it')}
              className="goal-create-button"
              onClick={() => toggle()}
            />
          </div>
        </Modal.Actions>
      </Modal>
    );
  }
}

/**
 * ActivityGoal
 *
 * The "goal" tab on the activity page.
 */
class ActivityGoal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      crossRefCurrentDoc: null,
      goalCrossReferenceId: null,
    };
  }

  async componentDidMount() {
    if (document.location.search === '?duplicate=true') {
      this.setState({
        modal: true,
      });
    }
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  goalStillOpen() {
    const { currentActivity } = this.props;

    const goalStatus = find(
      currentActivity.completionProgress,
      (o) => o.section === 'Goal'
    );

    return goalStatus.status === 0;
  }

  async setGoal({ target }) {
    const { t } = this.props;

    try {
      if (!this.goalStillOpen()) {
        return;
      }

      const { putActivity, currentActivity, policies } = this.props;

      const goal = find(
        currentActivity.derivedGoals,
        (o) => o.id == target.value
      );

      const primaryPolicy = find(policies, (o) => o.id == goal.primaryPolicyId);

      // set primary policy to the goal's primary, and nullify secondary policies
      const setPrimaryPolicyDomain = {
        primaryPolicy,
        primaryPolicyId: primaryPolicy.id,
        secondaryPolicy: {},
        secondaryPolicyId: null,
        goal: goal.goalTitle,
        goalDescription: goal.goalDescription,
        selectedPrimaryGoalId: target.value,
      };

      await putActivity('goal', setPrimaryPolicyDomain);
    } catch (error) {
      console.error('ActivityGoal -> setGoal -> error', error);
      NotificationManager.error(t('common.something_went_wrong'));
    }
  }

  async setPrimary({ target }) {
    const { t } = this.props;

    try {
      if (!this.goalStillOpen()) {
        return;
      }

      const { putActivity, policies } = this.props;
      const primaryPolicy = find(policies, (o) => o.id == target.value);

      // set primary policy to the selected one, and nullify secondary policies
      const setPrimary = {
        primaryPolicy: primaryPolicy || {},
        primaryPolicyId: target.value || null,
        secondaryPolicy: {},
        secondaryPolicyId: null,
      };

      await putActivity('goal', setPrimary);
    } catch (error) {
      // console.error('ActivityGoal -> setPrimary -> error', error);
      NotificationManager.error(t('common.something_went_wrong'));
    }
  }

  async setSecondary({ target }) {
    const { t } = this.props;

    try {
      if (!this.goalStillOpen()) {
        return;
      }

      const { putActivity, policies } = this.props;
      const secondaryPolicy = find(policies, (o) => o.id == target.value);

      // set secondary policy to the one selected
      const setSecondary = {
        secondaryPolicy: secondaryPolicy || {},
        secondaryPolicyId: target.value || null,
      };

      await putActivity('goal', setSecondary);
    } catch (error) {
      // console.error('ActivityGoal -> setSecondary -> error', error);
      NotificationManager.error(t('common.something_went_wrong'));
    }
  }

  renderObjectiveDomainOne() {
    const { t, outcomes, currentActivity } = this.props;

    const objectives = filter(outcomes, (o) => {
      return o.policyId == currentActivity.primaryPolicyId;
    });

    if (isEmpty(objectives) || currentActivity.goal === '') {
      return null;
    }

    return (
      <div className="goal-primary-policy-domain">
        <label className="objective-list-goal-header">
          {t('activity.goal.primary_policy_domain_objectives', {
            policy_name: currentActivity.primaryPolicy?.policyName || '',
          })}
        </label>
        {map(objectives, (item, i) => {
          if (!item.isEnable) {
            return null;
          }
          return (
            <label className="objective-list-goal-list" key={i}>
              &#8226; {item.title}
            </label>
          );
        })}
      </div>
    );
  }

  renderObjectiveDomainTwo() {
    const { t, outcomes, currentActivity } = this.props;

    const objectives = filter(
      outcomes,
      (o) => o.policyId == currentActivity.secondaryPolicyId
    );

    if (isEmpty(objectives)) {
      return null;
    }

    return (
      <div className="goal-secondary-policy-domain">
        <label className="objective-list-goal-header">
          {t('activity.goal.secondary_policy_domain_objectives', {
            policy_name: currentActivity.secondaryPolicy.policyName || '',
          })}
        </label>
        {map(objectives, (item, i) => {
          if (!item.isEnable) {
            return null;
          }
          return (
            <label className="objective-list-goal-list" key={i}>
              &#8226; {item.title}
            </label>
          );
        })}
      </div>
    );
  }

  renderObjectivesForPolicyDomain(policy) {
    const { outcomes } = this.props;

    const objectives = filter(outcomes, (o) => {
      return o.policyId == policy;
    });

    if (isEmpty(objectives)) {
      return null;
    }

    return (
      <div className="domain-list-goal-container">
        {map(objectives, (item, i) => {
          if (!item.isEnable) {
            return null;
          }
          return (
            <label className="domain-list-goal-list" key={i}>
              &#8226; {item.title}
            </label>
          );
        })}
      </div>
    );
  }

  async handleSecondaryPolicyChange(policy) {
    try {
      if (!this.goalStillOpen()) {
        return;
      }

      const { currentActivity, putParentDomain } = this.props;
      await putParentDomain(currentActivity.id, { policy });
    } catch (error) {
      // console.error('ActivityObjective -> handleSecondaryPolicyChange -> error', error);
    }
  }

  render() {
    let { t, currentActivity, user, helpTips, currentState } = this.props;
    const { modal } = this.state;

    const activityGoal =
      find(
        currentActivity.derivedGoals,
        (o) => o.id == currentActivity.selectedPrimaryGoalId
      ) || {};

    const allAvailablePolicyDomains = collect(
      [activityGoal.primaryPolicy].concat(activityGoal.secondaryPolicies || [])
    )
      .filter()
      .unique((policy) => policy.id)
      .all();

    // const isObjectivesSet = !isEmpty(currentActivity.objective);
    // const isGoalLocked = !this.goalStillOpen() && isObjectivesSet;
    const isGoalLocked = !this.goalStillOpen();

    const isParentActivity = isParentProgramActivity(
      currentActivity.activityPlanTypeId
    );

    // the list of secondary policy domains available
    // if we are a parent activity, and the goal is locked, then we only
    // show the secondary domains chosen from the pool
    const secondaryPolicyDomainList =
      isGoalLocked && isParentActivity
        ? (currentActivity.parentDomains || []).map((d) => d.policy)
        : allAvailablePolicyDomains;

    // use the derived goals for the activity (departments etc can have a subset of goals)
    const goalOptions = filter(currentActivity.derivedGoals, (f) => {
      return !f.isArchived && !f.isDeleted;
    });

    // model for the form
    const defaultForm = {
      goal: activityGoal.id || '',
      primary: currentActivity.primaryPolicyId || '',
      secondary: currentActivity.secondaryPolicyId || '',
    };

    return (
      <AvForm
        ref={(c) => (this.form = c)}
        className="activity-form"
        model={defaultForm}
      >
        <Segment
          className="content-segment-goal"
          disabled={getPageDisable(currentActivity, user, currentState)}
        >
          <RemainderDuplicate
            modal={modal}
            toggle={() => this.toggle()}
            {...this.props}
          />

          <Grid>
            {/* First row - goal & description */}
            <Grid.Row>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                {currentActivity.completionProgress[0].status >= 1 ? (
                  <div>
                    <label className="select-goal-label">
                      {' '}
                      <ProjectText
                        defaultText={t('formulary.placeholder.select_goal')}
                        textId={1}
                      />
                    </label>
                    <label className="act-goal-label form-control primary-goal-container">
                      {currentActivity.goal || ''}
                    </label>
                  </div>
                ) : (
                  <CustomTooltip
                    state={get(user, 'options.tips')}
                    contentObject={{
                      data: helpTips,
                      key: '20',
                    }}
                    position="bottom left"
                    wide="very"
                  >
                    <AvField
                      className="act-goal-inputs"
                      type="select"
                      name="goal"
                      label={
                        <div className="required-star-label">
                          {t('formulary.placeholder.select_goal')}
                        </div>
                      }
                      onChange={(e) => this.setGoal(e)}
                      disabled={isGoalLocked}
                    >
                      <option value="" disabled>
                        ({t('formulary.placeholder.select_your_goal')})
                      </option>
                      {map(goalOptions, (item, i) => (
                        <option key={i} value={item.id}>
                          {item.goalTitle}
                        </option>
                      ))}
                    </AvField>
                  </CustomTooltip>
                )}
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <div className="objective-list-goal-container-extra-margin">
                  <label className="objective-list-goal-header">
                    {t('common.goal_description')}
                  </label>

                  <ShowMoreText
                    lines={3}
                    more={t('common.read_more')}
                    less={t('common.read_less')}
                    anchorClass="show-more-less-clickable"
                    expanded={false}
                    truncatedEndingComponent={'... '}
                    className="pre-line"
                  >
                    <label className="objective-description-goal">
                      {currentActivity.goalDescription || '-'}
                    </label>
                  </ShowMoreText>
                </div>
              </Grid.Column>
            </Grid.Row>

            <Divider section />

            {/* Second row - primary domain & objectives */}
            <Grid.Row>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <CustomTooltip
                  state={get(user, 'options.tips')}
                  contentObject={{
                    data: helpTips,
                    key: '31',
                  }}
                  position="bottom left"
                  wide="very"
                >
                  {isGoalLocked ? (
                    <div>
                      <label className="required-star-label">
                        {t('formulary.primary_domain')}
                      </label>
                      <label className="act-goal-inputs form-control primary-goal-container">
                        {currentActivity.primaryPolicy?.policyName || ''}
                      </label>

                      {/****** not true any more - user can pick from primary + all secondaries
                      <small className="form-text text-muted">
                        <ProjectText defaultText="Assigned to goal" textId={2} />
                      </small>
                      *****/}
                    </div>
                  ) : (
                    <AvField
                      // tying "key" to the related model field forces a re-render when that field
                      // is updated in the model (there's a bug with legacy "availity" packages and
                      // model updates not propagating to <select> elements)
                      key={JSON.stringify(defaultForm.primary || '')}
                      className="act-goal-inputs"
                      type="select"
                      name="primary"
                      label={t('activity.goal.primary_policy_domain')}
                      helpMessage={
                        isGoalLocked ? null : (
                          <ProjectText
                            defaultText={t(
                              'activity.goal.select_primary_policy_domain_from_options'
                            )}
                            textId={3}
                          />
                        )
                      }
                      onChange={(e) => this.setPrimary(e)}
                      disabled={isGoalLocked}
                    >
                      <>
                        <option value="" disabled>
                          ({t('activity.goal.select_primary_policy_domain')})
                        </option>
                        <option value={0}>
                          {t('activity.goal.no_primary_domain_for_activity')}
                        </option>
                        {allAvailablePolicyDomains.map((domain, i) => {
                          return (
                            <option key={i} value={domain.id}>
                              {domain.policyName}
                            </option>
                          );
                        })}
                      </>
                    </AvField>
                  )}
                </CustomTooltip>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                {this.renderObjectiveDomainOne()}
              </Grid.Column>
            </Grid.Row>

            <Divider section />

            {/* Third row - secondary domain & objectives */}
            {isParentActivity ? (
              !isGoalLocked || !isEmpty(secondaryPolicyDomainList) ? (
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <div>
                      <CustomTooltip
                        state={get(user, 'options.tips')}
                        contentObject={{
                          data: helpTips,
                          key: '176',
                        }}
                        position="top left"
                        wide="very"
                      >
                        <div className="form-group-goal-heading">
                          {t('activity.goal.secondary_policy_domains_optional')}
                        </div>
                      </CustomTooltip>
                      <div className="form-group-goal-subheading text-muted">
                        {t(
                          'activity.goal.secondary_policy_populated_from_goal'
                        )}
                      </div>
                    </div>
                  </Grid.Column>
                  {map(secondaryPolicyDomainList, (item, i) => {
                    const checked = find(currentActivity.parentDomains, (o) => {
                      return o.policyId === item.id;
                    });
                    if (isGoalLocked && isEmpty(checked)) {
                      return;
                    }
                    return (
                      <Fragment key={i}>
                        <Grid.Column mobile={16} tablet={16} computer={8}>
                          <div className="domain-select-check">
                            <Checkbox
                              className="check-box"
                              label={`${item.policyName}`}
                              key={2}
                              value={item.id}
                              onChange={() =>
                                this.handleSecondaryPolicyChange(item.id)
                              }
                              checked={isEmpty(checked) ? false : true}
                              disabled={isGoalLocked}
                            />
                          </div>
                          {this.renderObjectivesForPolicyDomain(item.id)}
                        </Grid.Column>
                      </Fragment>
                    );
                  })}
                </Grid.Row>
              ) : null
            ) : !isGoalLocked || currentActivity.secondaryPolicyId ? (
              <Grid.Row className="gold-policy">
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <>
                    {isEmpty(allAvailablePolicyDomains) ? (
                      <>
                        {isObject(currentActivity.secondaryPolicy) && (
                          <div className="form-group">
                            <label className="">
                              {t('activity.goal.secondary_policy_domain')}
                            </label>
                            <label className="act-inputs-test form-control primary-goal-container">
                              {currentActivity.secondaryPolicy?.policyName ||
                                '-'}
                            </label>
                            <small className="form-text text-muted">
                              {t(
                                'activity.goal.secondary_policy_populated_from_goal'
                              )}
                            </small>
                          </div>
                        )}
                      </>
                    ) : (
                      <CustomTooltip
                        state={get(user, 'options.tips')}
                        contentObject={{
                          data: helpTips,
                          key: '176',
                        }}
                        position="top left"
                        wide="very"
                      >
                        {isGoalLocked ? (
                          <div>
                            <label className="required-star-label">
                              {t('activity.goal.secondary_policy_domain')}
                            </label>
                            <label className="act-goal-inputs form-control secondary-goal-container">
                              {currentActivity.secondaryPolicy?.policyName ||
                                ''}
                            </label>
                          </div>
                        ) : (
                          <AvField
                            // tying "key" to the related model field forces a re-render when that field
                            // is updated in the model (there's a bug with legacy "availity" packages and
                            // model updates not propagating to <select> elements)
                            key={JSON.stringify(defaultForm.secondary || '')}
                            className="act-goal-inputs"
                            type="select"
                            name="secondary"
                            label={t('activity.goal.secondary_policy_domain')}
                            helpMessage={
                              <ProjectText
                                defaultText={t(
                                  'activity.goal.select_secondary_policy_domain_from_options'
                                )}
                                textId={3}
                              />
                            }
                            onChange={(e) => this.setSecondary(e)}
                            disabled={isGoalLocked}
                          >
                            <>
                              <option value="" disabled>
                                (
                                {t(
                                  'activity.goal.select_secondary_policy_domain'
                                )}
                                )
                              </option>
                              <option value={0}>
                                (
                                {t(
                                  'activity.goal.no_second_domain_for_activity'
                                )}
                                )
                              </option>
                              {secondaryPolicyDomainList.map((domain, i) => {
                                return (
                                  <option key={i} value={domain.id}>
                                    {domain.policyName}
                                  </option>
                                );
                              })}
                            </>
                          </AvField>
                        )}
                      </CustomTooltip>
                    )}
                  </>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  {this.renderObjectiveDomainTwo()}
                </Grid.Column>
              </Grid.Row>
            ) : null}
          </Grid>
        </Segment>
      </AvForm>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.activity,
    policies: state.extra.policies,
    user: state.authentication.user,
    outcomes: state.extra.outcomes,
    helpTips: state.extra.activityHelpTips,
    crossRefDocuments: state.organization.crossRefDocuments,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      putActivity,
      putParentDomain,
    },
    dispatch
  );
};

ActivityGoal = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ActivityGoal));

export { ActivityGoal };
